import { gql } from '@apollo/client';

export const MY_CONNECTED_APPS = gql`
    query MyConnectedApps {
        myConnectedApps {
            id
            app
            schedulingLink
            email
            eventName
            status
        }
    }
`;
